import * as React from "react";
const SvgRectFill = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "currentColor", strokeWidth: 8, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12,16h40v32h-40z" }));
export default SvgRectFill;
